// Types
export const TYPE_HUMAN_AGENT = 1
export const TYPE_AI_AGENT = 2
